<template>
  <div>
    <Header title="我的地址" :show="true" />
    <LoadingModal />
    <van-address-list
      v-model="chosenAddressId"
      :list="list"
      default-tag-text="默认"
      @add="onAdd"
      @edit="onEdit"
      add-button-text="123123"
      @select="select"
    >
      <div slot="default" class="btn" :class="list.length>0?' top':''">
        <van-button type="default" block @click="toAdd">
          <van-icon class="iconfont iconadd-s" size="16" />
          <span>添加地址</span>
        </van-button>
      </div>
    </van-address-list>
  </div>
</template>
<script>
// import { getAddressList } from "api/user";
// import { setDefaultAddress } from "api/submit";
export default {
  data() {
    return {
      chosenAddressId: "",
      list: [],
      isexam: "",
    };
  },
  mounted() {
    let isexam = this.$route.query.isexam;
    this.isexam = isexam;
    this.getAddressList();
  },
  methods: {
    toAdd() {
      if (this.$route.query.isexam != undefined) {
        location.assign("/addAddress?isexam=1");
      } else if (this.$route.query.toPage != undefined) {
        location.assign("/addAddress?toPage="+this.$route.query.toPage);
      } else {
        location.assign("/addAddress");
      }
    },
    getAddressList() {
      // getAddressList().then((res) => {
      //   if (res.status == 1) {
      //     this.list = res.data;
      //     for (let index = 0; index < this.list.length; index++) {
      //       const element = this.list[index].id;
      //       if (this.list[index].isDefault) this.chosenAddressId = element;
      //     }
      //   }
      //   this.$nextTick(() => {
      //     this.$store.commit("setPageLoading", false);
      //   });
      // });
    },
    select(items) {
      this.chosenAddressId = items.id;
      this.list = this.list.map((item) => ({
        ...item,
        isDefault: item.id == items.id ? true : false,
      }));
      let isexam = this.$route.query.isexam;
      let toPage = this.$route.query.toPage;
      if (items.isDefault) {
        return;
      }
      this.$loading("处理中");
      // setDefaultAddress(items.id).then((res) => {
      //   this.$clear();
      //   if (res.status == 1) {
      //     if (isexam != undefined) {
      //       setTimeout(() => {
      //         // location.href = "/examination";
      //         this.$push({
      //           path: "/examination",
      //         });
      //       }, 100);
      //       //
      //     } else if (toPage!=undefined) {
      //       setTimeout(() => {
      //         this.$push({
      //           path:"/"+toPage+"?servicename="+toPage+"&isaddress=1"
      //         })
      //       }, 100);
      //     } else {
      //       this.$successSync("设置成功", () => {
      //         // this.getAddressList();
      //       });
      //     }
      //   }
      // });
    },
    onAdd() {
      location.href = "/addAddress";
    },
    onEdit(item) {
      location.assign("/addAddress?id=" + item.id);
    },
  },
};
</script>
<style lang="less" scoped>
.van-address-list {
  padding: 15px 15px 0px;
  .van-address-item {
    box-shadow: 0px 0px 5px rgba(215, 215, 215, 1);
    border-radius: 5px;
    .van-radio__icon .van-icon {
      font-size: 16px;
    }
    .van-address-item__edit {
      font-size: 24px;
    }
    .van-address-item__value {
      padding-right: 55px;
    }
  }
  .van-address-list__bottom {
    display: none;
  }
  .van-button__text {
    display: flex;
    align-items: center;
  }
}

.btn {
  button {
    i {
      margin-right: 5px;
    }
    border-radius: 5px;
  }
}
.top {
  margin-top: 15px;
}
</style>